<template>
    <nav class="bg-inherit hidden at1024:block">
        <h3
            v-if="header"
            class="text-base type-secondary font-medium mb-5 whitespace-nowrap"
        >
            {{ header }}
        </h3>
        <ul v-if="clickToScroll">
            <li v-for="(section, i) in sections" :key="i">
                <button
                    v-if="!section.isHidden"
                    :disabled="section.isDisabled"
                    @click.prevent="$emit('scrollTo', section.name)"
                    :class="
                        modelValue === section.name
                            ? 'bg-gray-150 border-blue type-primary'
                            : 'border-gray-150 text-gray'
                    "
                    class="block border-l-2 font-medium px-3 py-2 text-left truncate w-full hover:text-gray-800 disabled:opacity-50 disabled:hover:text-gray"
                >
                    {{ $t(section.name) }}
                </button>
            </li>
        </ul>
        <ul v-else>
            <li v-if="all">
                <button
                    @click="setFilter(null)"
                    :class="
                        !modelValue
                            ? 'bg-gray-tier-5 type-primary'
                            : 'type-secondary hover:bg-gray-tier-5 hover:type-primary'
                    "
                    class="block font-medium px-3 py-2 rounded-sm text-left truncate w-full disabled:opacity-50 disabled:hover:type-tertiary"
                >
                    {{ $t("All") }}
                </button>
            </li>
            <li v-for="(section, i) in sections" :key="i">
                <button
                    @click="
                        modelValue = section.name;
                        setFilter(section.name);
                    "
                    :class="
                        modelValue === section
                            ? 'bg-gray-tier-5 !type-primary'
                            : 'type-secondary hover:bg-gray-tier-5 hover:type-primary'
                    "
                    class="block font-medium px-3 py-2 rounded-sm text-left truncate w-full disabled:opacity-50 disabled:hover:type-tertiary"
                >
                    {{ $t(section.name) }}
                </button>
            </li>
        </ul>
    </nav>
</template>

<script setup>
import { useFilterHistory } from "@/Composables";

const { setFilter } = useFilterHistory();
const emits = defineEmits(["scrollTo", "update:modelValue"]);
const props = defineProps([
    "sections",
    "modelValue",
    "clickToScroll",
    "header",
    "all",
]);
</script>
